import {
  selectIsProjectSettingsModernizationFeatureFlagOn,
  selectIsWhatsAppInfobipLocalesEnabled,
} from 'core/userContext';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { Close24, Help16, WhatsAppLine16 } from 'ui/icons';
import { Link } from 'ui/links';
import { Popover, PopoverContent } from 'ui/popover';
import { colors } from 'ui/theme';
import { Trigger } from '@radix-ui/react-popover';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { pxToRem } from 'utils/convert';
import { useClickAway } from 'react-use';
import { WhatsApp } from 'ui/thirdPartyLogos/WhatsApp';

const StyledPopoverTrigger = styled(Trigger)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: ${colors.textDisabled};
`;

const StyledPopoverContent = styled(PopoverContent)`
  max-width: ${pxToRem(265)};
`;

const StyledSpan = styled.span`
  display: flex;
  align-items: center;
  gap: ${pxToRem(8)};
`;

const PROJECT_SETTINGS_URL = '/settings/project';
export const POPOVER_WHATSAPP_MENU_ITEM_BUTTON_TEST_ID = 'popover-whatsapp-menu-item-button';
export const ACTIVE_WHATSAPP_MENU_ITEM_BUTTON_TEST_ID = 'active-whatsapp-menu-item-button';
export const POPOVER_WHATSAPP_TEST_ID = 'popover-whatsapp';
export const SET_UP_A_LOCALE_BTN_TEST_ID = 'set-up-a-locale-btn';

export const WhatsAppMenuItem = ({
  setShouldCloseMainMenuOutside,
}: { setShouldCloseMainMenuOutside?: Dispatch<SetStateAction<boolean>> }) => {
  const isProjectSettingsModernizationEnabled = useSelector(
    selectIsProjectSettingsModernizationFeatureFlagOn,
  );
  const isWhatsAppGAFFon = useSelector(selectIsWhatsAppInfobipLocalesEnabled);
  const { locales } = useLocaleSettingsContext();
  const defaultLocale = locales[0];
  const [showPopover, setShowPopover] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  useClickAway(ref, () => {
    setShowPopover(false);
    setShouldCloseMainMenuOutside?.(true);
  });

  if (isWhatsAppGAFFon && !defaultLocale?.mappedWhatsAppInfobipLanguage) {
    return (
      <Popover open={showPopover}>
        <StyledPopoverContent
          ref={ref}
          data-test={POPOVER_WHATSAPP_TEST_ID}
          sideOffset={20}
          LinkContent={
            isProjectSettingsModernizationEnabled && (
              <Link href={PROJECT_SETTINGS_URL} data-test={SET_UP_A_LOCALE_BTN_TEST_ID}>
                {locales.length > 0 ? 'Configure locales' : 'Set up a locale'}
              </Link>
            )
          }
          TitleContent={
            <FlexSpacer justifyContent="space-between">
              <FlexSpacer>
                <WhatsApp width={24} height={24} /> Configure WhatsApp
              </FlexSpacer>

              <IconButton
                size={BUTTON_SIZES.SMALL}
                variant={BUTTON_VARIANTS.GHOST}
                onClick={() => {
                  setShouldCloseMainMenuOutside?.(true);
                  setShowPopover(false);
                }}
              >
                <Close24 />
              </IconButton>
            </FlexSpacer>
          }
          side="left"
          showArrow={false}
        >
          {locales.length > 0
            ? 'Create a locale-to-language mapping in Project Settings to create a WhatsApp template'
            : 'At least one locale is required to create a WhatsApp template'}
        </StyledPopoverContent>
        <StyledPopoverTrigger
          data-test={POPOVER_WHATSAPP_MENU_ITEM_BUTTON_TEST_ID}
          onClick={() => {
            setShowPopover(true);
            setShouldCloseMainMenuOutside?.(false);
          }}
          asChild
        >
          <div>
            <StyledSpan>
              <WhatsAppLine16 /> WhatsApp
            </StyledSpan>
            <Help16 />
          </div>
        </StyledPopoverTrigger>
      </Popover>
    );
  }
  return (
    <FlexSpacer data-test={ACTIVE_WHATSAPP_MENU_ITEM_BUTTON_TEST_ID}>
      <WhatsAppLine16 /> WhatsApp
    </FlexSpacer>
  );
};
